<template>
  <div class="steps-parent" :class="state == 'result' ? 'steps-parent-result' : ''">
    <input name="request_id" value="60" type="hidden">

    <transition name="step" appear>
      <app-start-screen
            v-if="state == 'start'"
            :is_result="is_result"
            @onStart="onStart"
            @onResult="onResult"
            :key="start"
            >
       </app-start-screen>

       <app-steps-screen
            v-else-if="state == 'steps' && is_step_show"
            :step="steps[index]"
            :stepIndex="index"
            :stepCount="Object.keys(steps).length"
            @onResultStep="onResultStep"
            :key="index"
            >
       </app-steps-screen>

       <app-result-screen
          v-else-if="state == 'result'"
          @onStart="onStart"
          :key="result"
       >

       </app-result-screen>
    </transition>
  </div>

</template>

<script>
export default {
  data () {
    return {
      state: 'start',
      steps: [],
      result: [],
      index: 0,
      is_step_show: false,
      is_result: false
    }
  },
  methods: {
    onStart(){
      this.index = 0;
      this.state = 'steps';
      this.is_step_show = true;
    },
    onResult(){
      if(this.is_result) {
        this.state = 'result';

      }
    },
    onResultStep(result) {
      this.is_step_show = false;
      let step = this.steps[this.index];

      for(let index in step.answer) {
        let answer = step.answer[index];

        if(result.length == 1 && result[0] == answer.id || result.indexOf(answer.id) >= 0) {
          this.result.push(answer.row_id);
        }
      }

      if(this.index + 1 <  this.steps.length) {
        this.index++;
        this.is_step_show = true;
      } else {
        this.setResultData();
        //this.onResult();
      }

    },
    /* Запись данных результата */
    setResultData() {
        if(this.result.length == 0) {
          return;
        }

        let response = this.$http.post('/requests/navigator/set_result', {
            result: this.result,
            request_id: $('#request_id').val()
        },{
          emulateJSON: true
        }).then((response) => {
            this.is_result = true;
            this.onResult();

        })

        this.result = [];
    },
    /** Получение массива классов. */
    getInitData() {
        this.$http.get("/requests/navigator/get_steps?alias="+ alias).then(response => {
          if (response.body.msg) {
            response.body.is_error ? showErrorMessage(response.body.msg) : showLoaded(response.body.msg);
          }
          if (response.body.is_error) {
            return;
          }
          this.steps = response.body.step_info;
        }, response => {
          showErrorMessage("Ошибка запроса.")
        });
    }
  },
  mounted() {
    this.getInitData();
    this.is_result = false;
    if(typeof is_step_result !== undefined) {
      this.is_result = is_step_result;
    }
  }
}
</script>

<style scoped>
  .steps-parent {
    width: 100%;
    height: 100%;
    min-height: 360px;
    margin-bottom: 50px;
  }


  .steps-parent-result {
    background-color: #fff;
  }

  .step-enter{

  }

  .step-enter-active{
    animation: slideIn 0.5s;
  }

  .step-enter-to{

  }

  .step-leave{
    position: absolute;
  }

  .step-leave-active{
    animation: slideOut 0.5s;
  }

  .step-leave-to{
    position: absolute;
  }

  @keyframes slideIn{
    from{transform: translateX(100vw);}
    to{transform: translateX(0px);}
  }

  @keyframes slideOut{
    from{transform: translateX(0px);}
    to{transform: translateX(-100vw);}
  }
</style>



// WEBPACK FOOTER //
// src/App.vue